import { render, staticRenderFns } from "./new-receipt-record.vue?vue&type=template&id=6904174f"
import script from "./new-receipt-record.vue?vue&type=script&lang=js"
export * from "./new-receipt-record.vue?vue&type=script&lang=js"
import style0 from "./new-receipt-record.vue?vue&type=style&index=0&id=6904174f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports